import React, { Component } from 'react';
import * as strings from '../../helpers/strings';
import Page from '../../common-components/Page';
import StationInfoAndHealthStatus from './StationInfoAndHealthStatus';
import RealtimeGraphs from './RealtimeGraphs';
import StatisticsAndWeatherInfo from './StatisticsAndWeatherInfo';
// import SocialMedia from './SocialMedia';

class DashboardScreen extends Component {
  render() {
    return (
      <Page title={strings.lblDashboard} >    
        <StationInfoAndHealthStatus/>
        <br />
        <StatisticsAndWeatherInfo/>
        <br />
        <RealtimeGraphs />
        {/* <br />
        <SocialMedia /> */}
      </Page>
    )
  }
}
export default DashboardScreen